import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Popover, TableColumnsType} from 'antd';

import {gray7} from '../../../../css/var-export.scss';
import {PopoverTextWrapper} from '../../../../layout/typography/popover-text-wrapper/popover-text-wrapper';
import {Locale} from '../../../../provider/locale/locale';

import {TagsEditTableRowDataType} from './tags-edit-table-type';
import * as styles from './tags-edit-table.scss';

export const tagColumnList: TableColumnsType<TagsEditTableRowDataType> = [
    {
        title: <Locale stringKey="TAGS__GROUP" />,
        dataIndex: 'tagName',
    },
    {
        title: (
            <Popover
                className={styles.TagsEditTable_requiredPopover}
                content={
                    <PopoverTextWrapper>
                        <Locale stringKey="TAG_GROUPS__REQUIRED__POPUP" />
                    </PopoverTextWrapper>
                }
                title={<Locale stringKey="TAG_GROUPS__REQUIRED__POPUP__TITLE" />}
            >
                <Locale stringKey="TAG_GROUPS__REQUIRED__TABLE__TITLE" />{' '}
                <FontAwesomeIcon color={gray7} icon={faCircleInfo} />
            </Popover>
        ),
        dataIndex: 'isRequired',
        width: 200,
    },
    {
        title: <Locale stringKey="TAGS__GROUP__ACTIONS" />,
        dataIndex: 'groupActions',
        width: 104,
    },
];
